import React, { useMemo } from "react";
import { Button, Icon, Typography } from "@mui/material";
import { Alert } from "@mui/material";

// import Location from "./Location";
import { joinCampaignHelper } from "@/features/campaigns/shared/helpers/joinCampaignHelper";
import PostcardCampaignLocation from "./PostcardCampaignLocation";
import LocationAdvancedSetting from "@/features/campaigns/digital/launch-digital-campaign/components/subscribedLocations/LocationAdvancedSetting";
import RpVirtualList from "@/components/virtual/RpVirtualList";
import useSearchFilter from "@/helpers/hooks/useSearchFilter";
import RpSvgIcon from "@/components/icons/RpSvgIcon";
import useIsParticipant from "@/features/auth/hooks/useIsParticipant";

function ActiveLocations({
  campaign,
  values,
  subscribedLocations = [],
  isSubmitting,
  setFieldValue,
  setFieldError,
  onSaveAsDraft,
  productList,
  getAdvanceSettingData,
  fillAdvancedSetting,
  setFillAdvancedSetting,
  isAdvancedSettingsFormValid,
  handleOnChangeAdvancedSettingError,
  setExpanded,
  expanded,
}) {
  const isPreview = !useIsParticipant();
  const { campaign_advanced_setting } = campaign;

  const filledLocations = useMemo(() => {
    const { locIds } = joinCampaignHelper.getPostCardValidLocations(
      values,
      campaign
    );
    return subscribedLocations.filter((l) => locIds.includes(String(l.id)));
  }, [values, campaign, subscribedLocations]);

  const [, , filteredSubscribedLocations] = useSearchFilter(
    subscribedLocations,
    ["location_name"]
  );

  const getTotal = useMemo(() => {
    // getting total of only fully filled locations
    return joinCampaignHelper
      .getPostCardLocTotal(
        joinCampaignHelper.getPostCardValidLocations(values, campaign)?.locs
      )
      .toFixed(2);
  }, [values, campaign]);

  const madeSelectionsIn = useMemo(() => {
    return joinCampaignHelper.getPostCardValidLocations(values, campaign)
      ?.locIds?.length;
  }, [values, campaign]);

  if (!subscribedLocations || subscribedLocations.length === 0) {
    return (
      <div className="my-5 text-center">
        <Alert severity="info">
          <strong>There is no active location.</strong>
        </Alert>
      </div>
    );
  }

  return (
    <div>
      {/* {fillAdvancedSetting === false && (
        <div className="row mb-3">
          <div className="col-md-4">
            <MuiSearchInput value={searchKey} onChange={handleSearchChange} />
          </div>
        </div>
      )} */}

      {fillAdvancedSetting === true && (
        <Typography variant="h6" className="mb-3">
          Advanced Settings
        </Typography>
      )}

      <div className="pb-5">
        {fillAdvancedSetting === false && (
          <RpVirtualList
            items={filteredSubscribedLocations}
            renderItem={(loc) => (
              <PostcardCampaignLocation
                loc={loc}
                locFormData={values[loc.id]}
                key={loc.id}
                setFieldValue={setFieldValue}
                setFieldError={setFieldError}
                expanded={expanded}
                setExpanded={setExpanded}
                campaign={campaign}
                productList={productList}
                getAdvanceSettingData={getAdvanceSettingData}
              />
            )}
          />
        )}
      </div>
      <div className="pb-5">
        {fillAdvancedSetting === true && (
          <RpVirtualList
            items={filledLocations}
            renderItem={(loc) => (
              <LocationAdvancedSetting
                loc={loc}
                locFormData={values[loc.id]}
                key={loc.id}
                setFieldValue={setFieldValue}
                setFieldError={setFieldError}
                expanded={expanded}
                setExpanded={setExpanded}
                campaign={campaign}
                productList={productList}
                getAdvanceSettingData={getAdvanceSettingData}
                handleOnChangeAdvancedSettingError={
                  handleOnChangeAdvancedSettingError
                }
                isDigitalCampaign={false}
              />
            )}
          />
        )}
      </div>
      <div className="card total-budget-box">
        <div className="card-body">
          <div className="total-budget">
            <Typography
              className="mr-2 fw-b mb-2 mb-sm-0"
              component="span"
              variant="body2"
            >
              Your Total Campaign Budget
            </Typography>

            <Button
              component="span"
              variant="outlined"
              disableElevation
              disableRipple
              startIcon={<Icon component={RpSvgIcon} name="money1" />}
            >{`$${getTotal} USD`}</Button>
          </div>
        </div>
      </div>
      {/* {!isEmpty(formError) && <RpSnackbar show message={formError.message} />} */}
      <div className="row justify-content-end align-items-center text-right my-4 actions">
        {subscribedLocations.length && (
          <div className="col-lg-5 mb-4 mb-lg-3">
            <Typography variant="caption">
              {`Selections complete for ${madeSelectionsIn} of ${subscribedLocations.length} locations.`}
            </Typography>
          </div>
        )}
        {campaign_advanced_setting?.is_required &&
          fillAdvancedSetting === false && (
            <>
              {!isPreview && (
                <div className="col-lg-2 mb-3 text-right">
                  <Button
                    color="primary"
                    size="large"
                    variant="outlined"
                    disabled={isSubmitting}
                    aria-disabled={isSubmitting}
                    onClick={onSaveAsDraft}
                    type="submit"
                    fullWidth
                  >
                    Save as Draft
                  </Button>
                </div>
              )}
              <div className="col-lg-3 mb-3 text-right">
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  disabled={isSubmitting}
                  aria-disabled={isSubmitting}
                  fullWidth
                  disableElevation
                  size="large"
                >
                  {isPreview ? "Confirm Selections" : "Next"}
                </Button>
              </div>
            </>
          )}

        {(!campaign_advanced_setting?.is_required ||
          fillAdvancedSetting === true) && (
          <>
            {campaign_advanced_setting?.is_required && (
              <div className="col-lg-2 mb-3 text-right">
                <Button
                  color="primary"
                  size="large"
                  variant="outlined"
                  disabled={isSubmitting}
                  aria-disabled={isSubmitting}
                  onClick={() => setFillAdvancedSetting(false)}
                  type="button"
                  fullWidth
                >
                  Back
                </Button>
              </div>
            )}
            {!isPreview && (
              <div className="col-lg-2 mb-3 text-right">
                <Button
                  color="primary"
                  size="large"
                  variant="outlined"
                  disabled={isSubmitting}
                  aria-disabled={isSubmitting}
                  onClick={onSaveAsDraft}
                  type="submit"
                  fullWidth
                >
                  Save as Draft
                </Button>
              </div>
            )}
            <div className="col-lg-3 mb-3 text-right">
              <Button
                variant="contained"
                color="primary"
                type="submit"
                disabled={isSubmitting || !isAdvancedSettingsFormValid}
                aria-disabled={isSubmitting || !isAdvancedSettingsFormValid}
                fullWidth
                disableElevation
                size="large"
              >
                Confirm Selections
              </Button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default ActiveLocations;
